// Async filter combined with map
export const asyncFilter = async (arr: any[], predicate: (r: any) => Promise<Boolean>): Promise<any[]> => {
  const results = await Promise.all(arr.map(predicate))

  return arr.filter((_v, index) => results[index])
}
